import { configure, defineRule } from 'vee-validate'
import { email, required } from '@vee-validate/rules'
import { localize } from '@vee-validate/i18n'
import i18n from '@/locales/I18n'

/**
 * vee-validateのユーザサイト向け初期設定を実施
 */
export default function vvConfigs() {
  /**
   * 定義の読込
   * vee-validateデフォルトの定義を使用する場合は以下URLを参照
   * https://vee-validate.logaretm.com/v4/guide/global-validators
   */
  defineRule('required', required)
  defineRule('emailFormat', email)
  defineRule('teamNameFormat', value => {
    if (!value || !value.length) return true
    const displayNameRegexp = /^.{1,128}$/
    return displayNameRegexp.test(value)
  })
  defineRule('displayNameFormat', value => {
    if (!value || !value.length) return true
    const displayNameRegexp = /^.{1,128}$/
    return displayNameRegexp.test(value)
  })
  defineRule('userIdFormat', value => {
    if (!value || !value.length) return true
    const userIdRegexp = /^[a-zA-Z0-9-_.~]{1,254}$/
    return userIdRegexp.test(value)
  })
  defineRule('passwordFormat', value => {
    if (!value || !value.length) return true
    const passwordRegexp = /^[a-zA-Z0-9-_.@!#$%&'*+/=?^`{|}~]{8,32}$/
    return passwordRegexp.test(value)
  })

  /**
   * 追加削除はlocale各ファイルに行うこと。
   * - src/locales/locales/en.json
   * - src/locales/locales/ja.json
   * 読み込み時にi18nから取得しvee-validateに読み込む
   */
  configure({
    generateMessage: localize({
      ja: {
        messages: i18n.global.messages.ja.veeValidateMessage,
      },
      en: {
        messages: i18n.global.messages.en.veeValidateMessage,
      },
      es: {
        messages: i18n.global.messages.es.veeValidateMessage,
      },
      fr: {
        messages: i18n.global.messages.fr.veeValidateMessage,
      },
      'pt-pt': {
        messages: i18n.global.messages.pt.veeValidateMessage,
      },
      de: {
        messages: i18n.global.messages.de.veeValidateMessage,
      },
      it: {
        messages: i18n.global.messages.it.veeValidateMessage,
      },
    }),
  })
}
